import React from 'react';
import RenderNative from './renderNative';
import Option from './Option';
import Value from './Value';
import { ThdSelectInput, ContentWrapper } from './styles';
import withSelect from '../../utils/withSelect';
import SelectWrapper from './selectWrapper';
import { commonDefaults, commonPropTypes } from './_commonProps';

class RenderNonNative extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
    this.selectRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleMouseDown = (e) => {
    e.preventDefault();
  }

  handleClickOutside = (e) => {
    if (this.selectRef.current && !this.selectRef.current.contains(e.target)) {
      this.closeSelect(e);
    }
  };

  handleChange = (option) => (e) => {
    this.closeSelect(e);
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(option);
  };

  toggleSelect = (e) => {
    const { disabled } = this.props;
    e.stopPropagation();

    if (!disabled) {
      this.setState((prevState) => ({ isActive: !prevState.isActive }));
    }
  };

  openSelect = (e) => {
    e.stopPropagation();
    this.setState(() => ({ isActive: true }));
  };

  closeSelect = (e) => {
    e.stopPropagation();
    this.setState(() => ({ isActive: false }));
  };

  selectOptions = () => {
    const {
      renderer,
      optionRenderer,
      options,
      keyBy,
      hrefBy,
      indexable,
    } = this.props;
    const OptionRenderer = renderer || optionRenderer;

    return options.map((option) => (
      <li
        role="presentation"
        key={keyBy(option)}
        onClick={this.handleChange(option)}
        onMouseDown={this.handleMouseDown}
      >
        <Option href={hrefBy(option)} indexable={indexable}>
          <OptionRenderer value={option} />
        </Option>
      </li>
    ));
  };

  render() {
    const { isActive } = this.state;
    const {
      renderer,
      valueRenderer,
      label,
      disabled,
      value,
      isWrapperOpen,
      nativeRenderer,
      onChange,
      ...rest
    } = this.props;
    const ValueRenderer = renderer || valueRenderer;

    // If nativeRenderer is provided, only render the native select
    if (nativeRenderer) {
      return (
        <SelectWrapper {...rest} isActive={isActive} ref={this.selectRef}>
          {label && <div className="attribute_label">{label}</div>}
          <RenderNative
            value={value}
            options={this.props.options}
            onChange={onChange}
            nativeRenderer={nativeRenderer}
            keyBy={this.props.keyBy}
            disabled={disabled}
          />
        </SelectWrapper>
      );
    }

    // Otherwise render the styled dropdown
    return (
      <SelectWrapper {...rest} isActive={isActive} ref={this.selectRef}>
        {label && <div className="attribute_label">{label}</div>}
        <ThdSelectInput
          onClick={this.toggleSelect}
          onBlur={this.closeSelect}
          disabled={disabled}
        >
          <Value disabled={disabled}>
            <ValueRenderer value={value} />
          </Value>
        </ThdSelectInput>
        <ContentWrapper
          isOpen={isWrapperOpen}
        >
          <ul className="listOptions drop-down__list">{this.selectOptions()}</ul>
        </ContentWrapper>
      </SelectWrapper>
    );
  }
}

RenderNonNative.propTypes = commonPropTypes;
RenderNonNative.defaultProps = commonDefaults;

export default withSelect(RenderNonNative);
